import {Action, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/StoreEnums";
import CustomerInboxService from "@/core/services/CustomerInboxService";

@Module
export default class CustomerInboxModule extends VuexModule {
  page: any = {
    loading: true,
    data: {
      total: 0,
      data: [],
      pages: 0,
    }
  }

  @Action
  [Actions.LOAD_CUSTOMER_INBOX](filter) {
    this.context.commit(Mutations.SET_CUSTOMER_INBOX, {
      loading: true, data: {
        total: 0,
        data: [],
        pages: 0,
      }
    })
    CustomerInboxService.findAll(filter).then(res => {
      this.context.commit(Mutations.SET_CUSTOMER_INBOX, {loading: false, data: res})
    })
  }

  @Mutation
  [Mutations.SET_CUSTOMER_INBOX](data) {
    this.page = data;
  }

}